import type { ReactElement } from 'react';
import { useRevalidator } from 'react-router-dom';

export const Refreshable = ({
  children,
}: {
  children: (props: { refresh: () => void }) => ReactElement;
}) => {
  const { revalidate } = useRevalidator();
  return children({ refresh: revalidate });
};
